import { useState } from 'react'

const useSort = ({ defaultOrderBy = 'room' }) => {
  const [orderBy, setOrderBy] = useState(defaultOrderBy)
  const [orderDirection, setOrderDirection] = useState<'asc' | 'desc' | undefined>('asc')

  const handleOrderBy = (newOrderBy) => {
    setOrderBy(newOrderBy)
    if (orderDirection !== 'asc') {
      setOrderDirection('asc')
    }
  }

  const handleOrderDirection = (newOrderDirection?: 'asc' | 'desc' | undefined) => {
    if (newOrderDirection) {
      if (['desc', 'asc'].includes(newOrderDirection)) {
        setOrderDirection(newOrderDirection)
      }
    } else {      
      setOrderDirection((prev) => (prev === 'desc' ? 'asc' : 'desc'))
    }
  }

  const compare = (a, b) => {
    if (!a[orderBy] || !b[orderBy]) {
      return 0
    }
    return a[orderBy].localeCompare(b[orderBy])
  }

  const compareSite = (a, b) => {
    if (!a.site_name || !b.site_name) {
      return 0
    }
    if (a.site_name && b.site_name) {
      return a.site_name.localeCompare(b.site_name)
    } else if (a.name_site && b.name_site) {
      return a.name_site.localeCompare(b.name_site)
    }

    return 0
  }

  const compareRoom = (a, b) => {
    if (a.name && b.name) {
      return a.name.localeCompare(b.name, undefined, {numeric: true})
    }
    return 0
  }

  const sort = (items) => {
    const rooms = [...items]
    return rooms.sort((a, b) => {      
      if (orderDirection === 'asc') {
        if (orderBy === 'site_name') {
          return compareSite(a, b)
        } else if (orderBy === 'room') {
          return compareRoom(a, b)
        } else {
          return compare(a, b)
        }
      } else {
        if (orderBy === 'site_name') {
          return compareSite(b, a)
        } else if ( orderBy === 'room') {
          return compareRoom(b, a)
        } else {
          return compare(b, a)
        }
      }
    })
  }

  return {
    orderByChange: (newOrderBy) => {
      if (newOrderBy === orderBy) {
        handleOrderDirection()
      } else {
        handleOrderBy(newOrderBy)
      }
    },
    orderBy,
    orderDirection,
    sort,
  }
}

export default useSort
